@if(error) {
  <div class="alert alert-danger">{{error}}</div>
}
<h1 data-automation-name="resourceEditor">
  @switch(editing) {
    @case(true) {
      <span>Edit Resource {{resourceId}}</span>
    }
    @case(false) {
      <span>Register a new Resource</span>
    }
  }
</h1>
<form name="resourceForm" class="form-horizontal" [formGroup]="resourcesForm">
  <div class="form-group">
    <label for="resourceId"> Resource id: </label>
    <input id="resourceId" class="form-control" name="resource_id" type="text" formControlName="id" required>
    @if(resourcesForm.get('id')?.invalid && (resourcesForm.get('id')?.dirty || resourcesForm.get('id')?.touched)) {
      <div class="text-danger">
        <div *ngIf="resourcesForm.get('id')?.errors?.['required']">Resource ID is required.</div>
      </div>
    }
  </div>
  <div class="form-group">
    <label for="program_unit"> Registration UUID: </label>
    <input id="program_unit" class="form-control" name="program_unit" type="text" formControlName="programUnit" required>
    @if(resourcesForm.get('programUnit')?.invalid && (resourcesForm.get('programUnit')?.dirty || resourcesForm.get('programUnit')?.touched)) {
      <div class="text-danger">
        <div *ngIf="resourcesForm.get('programUnit')?.errors?.['required']">Registration UUID is required.</div>
      </div>
    }
  </div>
  <div class="form-group">
    <label for="label"> Label: </label>
    <input id="label" class="form-control" name="label" type="text" formControlName="label">
  </div>

  <button id="save" class="btn btn-primary" type="button" (click)="save()" [disabled]="resourcesForm.invalid">Save</button>
  <a class="btn" (click)="backPage('/resources', router)">Cancel</a>
</form>
